<template>
  <div class="dashboard">
    <Login v-if="this.$store.state.userData == null" />
  </div>
</template>

<script>
// @ is an alias to /src
import Login from '@/components/Login.vue'
import Api from '@/Api.js';

export default {
  name: 'DashboardView',
  components: {
    Login,
  },
  watch: {
    '$store.state.userData': function() {
      this.redirectToAutomations();
    }
  },
  data() {
    return {
      authCredentials: []
    };
  },
  methods: {
    getAuthCredentials() {
      Api.post('credentials.list', null, this.$store.state.userData.accessToken, this).then(response => {
        this.authCredentials = response.result.credentials;
      });
    },
    refreshData() {
      if (this.$store.state.userData != null) this.getAuthCredentials();
    },
    redirectToAutomations() {
      if (this.$store.state.userData != null) {
        this.$router.push('/automations');
      }
    }
  },
  mounted() {
    this.redirectToAutomations();
    this.refreshData();
  }
}
</script>
